import React from 'react';
import ReactDOM from 'react-dom/client';
import './shared/styles/index.css';
import './shared/styles/accessibility.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// La landing no toca el service worker: ni lo registra ni lo elimina.
//
// Comparte origen con la app (tumesaya.com/login, el wizard de alta y todo el
// panel), y el dueño del service worker en scope `/` es Nuxt (@vite-pwa/nuxt).
// Dos workers en el mismo scope se pisan, así que aquí no se registra ninguno.
//
// Tampoco se llama a unregister(): `navigator.serviceWorker.ready` resuelve al
// registro que controla el scope `/`, que ahora es el de Nuxt — desregistrarlo
// tiraría la caché de la PWA cada vez que alguien pasa por la portada.
//
// Los registros que dejó la versión anterior de la landing se limpian solos: su
// worker vivía en /sw.js y esa ruta la sirve ahora nginx desde Nuxt, así que en
// la siguiente comprobación de actualización el navegador lo reemplaza.
